// Font Loading Utility for AWM
// Optimizes font loading and provides fallback handling

export const loadFonts = () => {
  // Check if fonts are already loaded
  if (document.fonts && document.fonts.check) {
    const checkFont = (fontFamily: string, fontWeight: string = '400') => {
      return document.fonts.check(`16px ${fontFamily}`);
    };

    // Preload critical fonts
    const criticalFonts = [
      { family: 'Blacklist', weight: '700' },
      { family: 'Blacklist', weight: '900' },
      { family: 'Montserrat', weight: '400' },
      { family: 'Montserrat', weight: '500' },
      { family: 'Montserrat', weight: '700' },
    ];

    // Load fonts with fallback
    criticalFonts.forEach(({ family, weight }) => {
      if (!checkFont(family, weight)) {
        // Font not loaded, add loading class
        document.documentElement.classList.add('fonts-loading');
      }
    });

    // Remove loading class when fonts are loaded
    document.fonts.ready.then(() => {
      document.documentElement.classList.remove('fonts-loading');
      document.documentElement.classList.add('fonts-loaded');
    });
  }
};

// Font loading states for CSS
export const fontLoadingStates = {
  loading: 'fonts-loading',
  loaded: 'fonts-loaded',
  failed: 'fonts-failed',
};

// Critical font families
export const criticalFonts = {
  display: 'Blacklist',
  body: 'Montserrat',
};

// Font weights used in the application
export const fontWeights = {
  thin: '100',
  extralight: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '700',
  extrabold: '800',
  black: '900',
};

// Initialize font loading
if (typeof window !== 'undefined') {
  loadFonts();
}
